var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0h-11c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-1h2.75V12H11.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5h5c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5h-1.25V2.5H18v1c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5zm-10 6h-9c-.276 0-.5.224-.5.5v2c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5V8h1.75v4H3c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5h4c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5h-.75V8H8v.5c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-2c0-.276-.224-.5-.5-.5z",
    transform: "translate(2 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSize);
export default __webpack_public_path__ + "static/media/text-size.b7f97d1fbcfd8d7ff954290fb42d92ad.svg";
export { ForwardRef as ReactComponent };